/* Copyright 2012-13 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "dijit/_Container",
    "./_WidgetMixin",
    "dojo/text!./templates/FooterCell.html",
    "./_ChildrenWrapperMixin"
], function (declare, _WidgetBase, _TemplatedMixin, _Container, _WidgetMixin, template, _ChildrenWrapperMixin) {
    return declare([_WidgetBase, _TemplatedMixin, _Container, _ChildrenWrapperMixin, _WidgetMixin], {

        templateString: template,
        baseClass: "footerCell"
    });
});
